/**
 * This code was generated by Builder.io.
 */
import React from "react";
import styles from "./SelectOffice.module.css";
import OfficeList from "./OfficeList";
import NavigationButtons from "./NavigationButtons";
import StepperHeader from "./StepperHeader";

const SelectOffice: React.FC = () => {
  return (
    <div className={styles.selectOffice}>
      <main className={styles.mainContent}>
        <StepperHeader />
        <p className={styles.selectedPremium}>
          <strong>Selected Premium :</strong> Adjustment Premium
        </p>
        <OfficeList />
        <NavigationButtons />
      </main>
    </div>
  );
};

export default SelectOffice;
